// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('appPurchase/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('appPurchase/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))

  const consolidated_response = await axios.get('/PurchaseInvoices/ConsolidatedList', { params: { ...params, ServiceInvoice: false } })

  dispatch(setLoading({ getData: false }))

  return {
    params,
    data: {data: {list: [], totalRecords: 0}},
    consolidated: consolidated_response.data
  }
})

export const getPurchaseActivityLogData = createAsyncThunk('appPurchase/getPurchaseActivityLogData', async (recno, { dispatch }) => {
  dispatch(setLoading({ getPurchaseActivityLogData: true }))
  const response = await axios.get(`/PurchaseInvoices/GetPurchaseLog/${recno}`)
  dispatch(setLoading({ getPurchaseActivityLogData: false }))
  return {
    data: response.data
  }
})

export const getTypeData = createAsyncThunk('appPurchase/getTypeData', async (params, { dispatch }) => {
  dispatch(setLoading({ getTypeData: true }))
  const response = await axios.get('/JVTypes/List', { params })
  dispatch(setLoading({ getTypeData: false }))
  return {
    params,
    data: response.data
  }
})

export const getJournal = createAsyncThunk('appPurchase/getJournal', async (recno, { dispatch }) => {
  dispatch(setLoading({ getJournal: true }))
  const response = await axios.get(`/PurchaseInvoice/${recno}`)
  dispatch(setLoading({ getJournal: false }))

  return response.data
})

export const deleteInvoice = createAsyncThunk('appPurchase/deleteInvoice', async (id, { dispatch, getState }) => {
  dispatch(setLoading({ deleteInvoice: true }))
  await axios.delete('/apps/invoice/delete', { id })
  await dispatch(getData(getState().invoice.params))
  dispatch(setLoading({ deleteInvoice: false }))
  return id
})

export const appPurchaseSlice = createSlice({
  name: 'appPurchase',
  initialState: {
    vendorInvoice: {},
    data: [],
    activityLogs: [],
    totalRecords: 1,
    consolidatedTotalRecords: 1,
    typeData: [],
    totalTypeRecords: 1,
    totalLogsRecords: 1,
    params: {},
    typeParams: {},
    loadingState: { getData: false, getTypeData: false, getJournal: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data.data.list
        state.consolidated = action.payload.consolidated?.data?.list??[]
        state.totalRecords = action.payload.data.totalRecords
        state.consolidatedTotalRecords = action.payload.consolidated?.totalRecords??0
        state.params = action.payload.params
      })
      .addCase(getPurchaseActivityLogData.fulfilled, (state, action) => {
        state.activityLogs = action.payload.data.data.list
        state.totalLogsRecords = action.payload.data.totalRecords
      })
      .addCase(getTypeData.fulfilled, (state, action) => {
        state.typeData = action.payload.data.data.list
        state.totalTypeRecords = action.payload.data.totalRecords
        state.typeParams = action.payload.params
      })
      .addCase(getJournal.fulfilled, (state, action) => {
        state.journal = action.payload
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default appPurchaseSlice.reducer
